const normalizeCpfCnpj = (value: string): string =>
  String(value || "")
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, "")
    .slice(0, 14);

const applyMask = (
  value: string,
  slices: number[],
  separators: string[]
): string => {
  let start = 0;

  return slices.reduce((formatted, size, index) => {
    const chunk = value.slice(start, start + size);
    start += size;

    if (!chunk) return formatted;

    const separator =
      formatted && chunk.length === size ? separators[index - 1] || "" : "";

    return `${formatted}${separator}${chunk}`;
  }, "");
};

export const formatCpfCnpjDisplay = (value: string): string => {
  const normalized = normalizeCpfCnpj(value);

  if (!normalized) return "";

  const onlyDigits = /^\d+$/.test(normalized);

  if (onlyDigits && normalized.length <= 11) {
    return applyMask(normalized, [3, 3, 3, 2], [".", ".", "-"]);
  }

  return applyMask(normalized, [2, 3, 3, 4, 2], [".", ".", "/", "-"]);
};

